import { render, staticRenderFns } from "./VisitNewView.vue?vue&type=template&id=3dcb2c4a&scoped=true"
import script from "./VisitNewView.vue?vue&type=script&lang=ts"
export * from "./VisitNewView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcb2c4a",
  null
  
)

export default component.exports